<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span> <span class="tituloUnidad">Unidad1</span></h1>
                <h1 class="animated bounceIn dura-2 ml-3">Generalidades del monitoreo de atmósferas</h1>
                <h2 class="animated bounceIn dura-3">Conceptos básicos</h2>
                <p class="animated fadeIn dura-4">
                    Iniciemos revisando algunos conceptos básicos que son muy importantes para el monitoreo de atmósferas.
                </p>
                <p class="FontBase-SemiBoldItalic animated bounceIn dura-7 tituloUnidad">Haz clic en cada ícono para ampliar la información.
                </p>
            </v-flex>
        </v-layout>
                  <v-layout wrap row justify-center align-center text-xs-center pb-5 class="cont_page">
                <v-flex xs12 sm6 md2 class="animated bounceIn dura-1">
                <svgmod1></svgmod1>
                </v-flex>
                <v-flex xs12 sm6 md2 class="animated bounceIn dura-2">
                <svgmod2></svgmod2>
                </v-flex>
                <v-flex xs12 sm6 md2 class="animated bounceIn dura-3">
                <svgmod3></svgmod3>
                </v-flex>
                <v-flex xs12 sm6 md2 class="animated bounceIn dura-4">
                <svgmod4></svgmod4>
                </v-flex>
            </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 class="cont_page" v-show="this.$store.state.vistosAllMod3">
            <scrolldown-app></scrolldown-app>
            <v-flex xs12 sm9 md7 class="text-xs-left">
                <h2 class="animated bounceIn dura-3">Conceptos básicos</h2>
                <p class="animated fadeIn dura-4">
                    El siguiente diagrama muestra la mezcla de gas combustible y aire, indicando el Límite Inferior de Explosividad (LEL) y el Límite Superior de Explosividad (UEL).
                </p>
                <p class="FontBase-SemiBoldItalic animated bounceIn dura-7 tituloUnidad">Haz clic en los botones LEL y UEL para ampliar la información
                </p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center pantalla">
                <img src="@/assets/unidad1/pantalla-4-6.png" alt="">
                <div class="botones">
                    <img v-if="!visto1" @click="evaluar(1)" class="mr-5" src="@/assets/unidad1/pantalla-4-6-boton-1.png" alt="">
                    <img v-if="visto1" @click="evaluar(1)" class="mr-5" src="@/assets/unidad1/pantalla-4-6-boton-1-check.png" alt="">
                    <img v-if="!visto2" @click="evaluar(2)" src="@/assets/unidad1/pantalla-4-6-boton-2.png" alt="">
                    <img v-if="visto2" @click="evaluar(1)" src="@/assets/unidad1/pantalla-4-6-boton-2-check.png" alt="">
                </div>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center mobile">
                <img src="@/assets/unidad1/pantalla-4-6--mobile.png" alt="">
                <div class="botones">
                    <img v-if="!visto1" @click="evaluar(1)" class="mr-5" src="@/assets/unidad1/pantalla-4-6-boton-1.png" alt="">
                    <img v-if="visto1" @click="evaluar(1)" src="@/assets/unidad1/pantalla-4-6-boton-1-check.png" alt="">
                    <img v-if="!visto2" @click="evaluar(2)" src="@/assets/unidad1/pantalla-4-6-boton-2.png" alt="">
                    <img v-if="visto2" @click="evaluar(2)" src="@/assets/unidad1/pantalla-4-6-boton-2-check.png" alt="">
                </div>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left" v-if="vistosAll">
                <h2 class="animated bounceIn dura-1">Ejemplo</h2>
                <p class="animated bounceIn dura-2">
                    La siguiente gráfica representa el límite LEL y UEL para el Acetileno. En este caso, el Límite Inferior de Explosividad es del 2% y el Límite Superior de Explosividad es del 81%.
                </p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center pantalla" v-if="vistosAll">
                <svgmod></svgmod>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center mobile" v-if="vistosAll">
                <button class="hvr hvr-hover btn-img--wb" @click="$store.commit('nextShow', true)">
                        <a href="documents/unidad1/Pantalla 4-2.pdf" target="_blank">
                            <img class="anim-zoom animated flipInY dura-2"
                                src="../../assets/imagenes_compartidas/boton-descarga.png" alt="boton-descarga">
                        </a>
                    </button>
            </v-flex>
        </v-layout>
        <modal-app v-model="modala" :fullscreen="false" width="700px">
            <template slot="modaltittle"></template>
            <template slot="modalcontent">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12>
                        <h2>LEL</h2>
                        <p>Mínima concentración de gas combustible que al combinarse con el aire a presión atmosférica puede provocar combustión. También se conoce como Límite Inferior de Explosividad (Lower Explosive Limited).</p>
                        <p class="text-xs-center" v-if="modala ">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/CdTiA6v3eyQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </p>
                        <p class="text-xs-center"><i>Fuente: Egarsat Mutua</i></p>                      
                    </v-flex>
                </v-layout>
            </template>
        </modal-app>
        <modal-app v-model="modalb" :fullscreen="false" width="700px">
            <template slot="modaltittle"></template>
            <template slot="modalcontent">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12>
                        <h2>UEL</h2>
                        <p>Máxima concentración de gas combustible que, a presión atmosférica y en combinación con el aire, puede crear combustión (explosión) y donde finaliza la zona explosiva. Conocido como límite superior de explosividad (Uper Explosive Limited).</p>
                    </v-flex>
                </v-layout>
            </template>
        </modal-app>
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
import svgmod from "./svg/mod3"
import svgmod1 from "./svg/mod3-1"
import svgmod2 from "./svg/mod3-2"
import svgmod3 from "./svg/mod3-3"
import svgmod4 from "./svg/mod3-4"
export default {
    components: {
        svgmod,
        svgmod1,
        svgmod2,
        svgmod3,
        svgmod4,

    },
    mixins: [nextConditions],
    data() {
        return {
            modala: false,
            visto1: false,
            visto2: false,
            modala: false,
            modalb: false,
            vistosAll: false,
        }
    },
    methods: {
        opemModalSgv() {
            this.modalsvg = true
        },
        evaluar(option) {
            if (option == 1) {
                this.modala = true;
                this.visto1 = true;
            }
            if (option == 2) {
                this.modalb = true;
                this.visto2 = true;
            }
            if (this.visto1 && this.visto2) {
                setTimeout(() => {
                    this.$store.commit('nextShow', true)
                }, 3000);
                this.vistosAll = true;
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.$store.commit('nextShow', false)
        }, 3000);
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
.mostrar {
    display: block;
}

.esconder {
    display: none;
}

.icon-titulo {
    content: url('../../assets/imagenes_compartidas/icon-titulo.png');
    align-items: center;
    justify-content: start;
    width: 15px;
    height: 15px;
}

ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    padding-left: 10px;
}

ol li {
    counter-increment: my-awesome-counter;
    display: flex;
    align-items: center;
    justify-content: start;
    span {
        margin: 0.5em;
        padding: 0.5em;
        border-left: 2px solid $color-complement-one;
    }
}

ol li::before {
    content: counter(my-awesome-counter) ". ";
    color: $color-primary;
    font-weight: bold;
    margin-right: 0.01em;
}

li {}

.container-module {
    text-align: left;
    p {
        margin: 0;
        padding: 0;
    }
    img {
        width: 80px;
        display: inline-block;
        vertical-align: middle;
    }
    .modulo-name {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        text-align: left;
        padding-left: 10px;
    }
    @media screen and (max-width: 500px) {
        text-align: center;
        img {
            width: 40%;
        }
        .modulo-name {
            width: 100%;
            padding-left: 0px;
        }
    }
}

h1 {
    line-height: 80% !important;
}

.tituloUnidad {
    color: $color-primary;
}

.pantalla {
    @media screen and (max-width: 600px) {
        display: none;
    }
}

.mobile {
    @media screen and (min-width: 600px) {
        display: none;
    }
    @media screen and (max-width: 600px) {
        display: block;
    }
}

.botones {
    margin-right: 35%;
    cursor: pointer;
}
</style>